import React from 'react';

export default function ({ children }) {
  return (
    <div className="playground">
      <div className="cornerBubble">
        <svg aria-hidden="true">
          <use xlinkHref="/sprite.svg#icon-demo" />
        </svg>
      </div>
      <div className="playground__header">Playground</div>
      <div className="playground__body">{children}</div>
    </div>
  );
}
